import { ApiError, NetworkError } from './apiClient.js';
import { prepareImageForUpload } from './resizeImage.js';

/**
 * מעלה תמונה בינארית (לא JSON) ליומן השדה; מחזיר את ה-URL היחסי שנשמר בשרת. התמונה מכווצת לפני ההעלאה
 * (ראו resizeImage.ts) — העלאה מהירה יותר ובדיקת התמונה האוטומטית עובדת על קובץ קטן.
 */
export async function uploadImage(original: Blob, timeoutMs = 30_000): Promise<string> {
  const blob = await prepareImageForUpload(original);
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch('/api/player/uploads', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': blob.type || 'image/jpeg' },
      body: blob,
      signal: controller.signal,
    });
    const body = (await res.json().catch(() => null)) as { ok?: boolean; url?: string; error?: string } | null;
    if (!res.ok || !body?.ok || !body.url) {
      throw new ApiError(body?.error ?? `שגיאת שרת (${res.status})`, res.status, body);
    }
    return body.url;
  } catch (e) {
    if (e instanceof ApiError) throw e;
    if (e instanceof DOMException && e.name === 'AbortError') {
      throw new NetworkError('העלאת התמונה חרגה מזמן ההמתנה');
    }
    throw new NetworkError();
  } finally {
    clearTimeout(timeout);
  }
}
